import React from "react";

import MenuListItem from "./MenuListItem";

const iconChurch = new URL("../assets/images/icon-church.svg", import.meta.url);
const iconUrn = new URL("../assets/images/icon-urn.svg", import.meta.url);
const iconBook = new URL("../assets/images/icon-book.svg", import.meta.url);
const iconBird = new URL("../assets/images/icon-bird.svg", import.meta.url);

export default function MenuList() {
  return (
    <div className="bg-[#E9E3D0] py-[50px] px-6 text-dark-blue flex flex-col gap-2">
      <MenuListItem
        key={1}
        icon={iconChurch}
        title="begravning med cermoni"
        link="https://fenixbegravning.se/begravning-med-ceremoni/stockholm/"
      />
      <MenuListItem
        key={2}
        icon={iconUrn}
        title="direktkremation"
        link="https://fenixbegravning.se/direktkremering/stockholm/"
      />
      <MenuListItem
        key={3}
        icon={iconBook}
        title="begravning med cermoni & bouppteckning"
        link="https://fenixbegravning.se/begravning-med-ceremoni-bouppteckning/stockholm/"
      />
      <MenuListItem
        key={4}
        icon={iconBird}
        title="anpassad begravning"
        link="https://fenixbegravning.se/anpassad-begravning/stockholm/"
      />
    </div>
  );
}
